import { stringToColor } from "../colorUtils";
import { IconButton } from "../IconButton";
import SingleTextEditor from "./SingleTextEditor";


function createGroupId() {
    // generate UUIDv4 and use the last 8 chars
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)).slice(0,8);
  }

export default function ManualGroupIdEditor({ value, onChange }) {
    return <div>
    <span className={'d-inline-block'} style={{width: '100px'}}>
      <SingleTextEditor style={{backgroundColor: value ? stringToColor(value)+'55' : 'white'}} small value={value} onChange={s => onChange(s || undefined)}/>
    </span>
    { !value ? <IconButton icon={'add_circle'} level={'success'} onClick={() => onChange(createGroupId())}/> : null }
  </div>
}